import React, { Component } from 'react';
import { 
  Row,
  Collapse, 
  Container,
  Navbar, 
  NavbarBrand, 
  NavbarToggler, 
  NavItem, 
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { RoleDropdown} from './RoleDropdown';
import './NavMenu.css';
import logo from '../img/logo x home.png'
import logoEsseti from '../img/Esseti.png'

const navStyle = {
  color: 'white'
}
const Vers =
{
    Color:'#011e41'
}

export class Footer extends Component{
    render() {
        return(
            <Container fluid>
                <div className="fixed-bottom" style={{ width: "100vw", margin: "0px", padding: "0px" , borderTop: "1px solid #011e41"}}>  
                    <Navbar className="navbar-expand-md navbar-toggleable-md ng-white border-bottom box-shadow mb-3" dark>
                        <Container>
                        <NavbarBrand className="mx-auto" href="http:\\essetiweb.it" to="/"><img style={{ height: 35, width: 90 }} src={logoEsseti} alt="Renieri"></img><span style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }} class="navbar-text align-middle"> v.1.8</span></NavbarBrand>
                        </Container>
                    </Navbar>
                </div>
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js